/**
 * بوّابة موحَّدة لكلّ admin hooks تستدعي server functions.
 * تُرجع `ready` فقط عندما يكتمل auth + role والمستخدم أدمن فعلاً.
 *
 * الاستخدام:
 *   const { ready } = useAdminGate(enabled);
 *   useQuery({ enabled: ready, ... });
 *
 * @param enabled تمكين خارجي اختياري (افتراضي true)
 * @param scope  "admin" (افتراضي) | "staff" — لاستخدام مستقبلي للوحات staff-only
 */
import { useAuthOptional } from "@/contexts/AuthContext";
import { useIsAdmin } from "@/hooks/useIsAdmin";

export function useAdminGate(enabled = true, scope: "admin" | "staff" = "admin") {
  const { user, loading: authLoading } = useAuthOptional();
  const { isAdmin, hasAdminAccess, loading: roleLoading } = useIsAdmin();

  const allowed = scope === "staff" ? hasAdminAccess : isAdmin;
  const ready = enabled && !authLoading && !roleLoading && !!user && allowed;

  return { ready, user, isAdmin, hasAdminAccess, loading: authLoading || roleLoading };
}
